import { useState, useRef } from 'react';
import './VideoGrid.css';

const VideoItem = ({ path, video }) => {
  const fileName = path + "/" + video;
  const host = "https://" + window.location.hostname + ":3001";
  const videoUrl = host + "/video?video=" + fileName;

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  // Function to toggle play/pause of the video
  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div>
      <div className={`video-item ${isPlaying ? 'playing' : ''}`} >
        <video
          ref={videoRef}
          src={videoUrl}
          // onClick={togglePlayPause}
          // w-full and h-full ensure the video fills its container
          // object-contain ensures the video maintains its aspect ratio within the bounds
          className="w-full h-full object-contain cursor-pointer rounded-lg"
          controls={true} // We will handle play/pause manually
        >
          Your browser does not support the video tag.
        </video>
        {
          !isPlaying && (
            <div
              className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 rounded-lg cursor-pointer"
              onClick={togglePlayPause}
            >
              <svg
                className="w-20 h-20 text-white opacity-90 video-overlay-icon"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
          )
        }
      </div>
      <div className="text-center">
        <a
          href={videoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 hover:text-blue-800 text-lg font-medium underline transition duration-200 ease-in-out"
        >
          Open in New Tab
        </a>
      </div>
    </div>

  );
};

const VideoGrid = ({ path, videoList, thumbnailSize }) => {
  if (videoList) {
    return (
      <div className="video-grid-container">
        <h2 className="video-grid-header">{path}</h2>
        <div className="video-grid" style={{ '--column-width': `${thumbnailSize}px`}}>
          {videoList.map((video, index) => (
            <VideoItem key={index} path={path} video={video} />
          ))}
        </div>
      </div>
    );
  }
};

export default VideoGrid;